<template>
  <div id="user-edit-tab-account">
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <vs-avatar :src="avatar" size="80px" class="mr-4" />
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">
              {{ data_local.details.firstName }} {{ data_local.details.lastName }}
            </p>
            <input
              type="file"
              class="hidden"
              ref="update_avatar_input"
              @change="update_avatar"
              accept="image/*"
            />

            <vs-button type="border" @click="$refs.update_avatar_input.click()" class="mr-4 mb-4"
              >{{ $t('forms.change') }} {{ $t('users.avatar') }}</vs-button
            >
            <vs-button type="border" @click="remove_avatar" color="danger"
              >{{ $t('forms.remove') }} {{ $t('users.avatar') }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-2/3 w-full">
        <vs-input
          class="w-full mt-4"
          :label="$t('users.username')"
          v-model="data_local.username"
          v-validate="'required|phone:mobile'"
          name="username"
        />
        <span class="text-danger text-sm" v-show="errors.has('username')">{{
          errors.first('username')
        }}</span>

        <vs-input
          class="w-full mt-4"
          :label="$t('users.first_name')"
          v-model="data_local.details.firstName"
          v-validate="'required|letters'"
          name="firstName"
        />
        <span class="text-danger text-sm" v-show="errors.has('firstName')">{{
          errors.first('firstName')
        }}</span>

        <vs-input
          class="w-full mt-4"
          :label="$t('users.last_name')"
          v-model="data_local.details.lastName"
          v-validate="'required|letters'"
          name="lastName"
        />
        <span class="text-danger text-sm" v-show="errors.has('lastName')">{{
          errors.first('lastName')
        }}</span>

        <vs-input
          class="w-full mt-4"
          :label="$t('users.email')"
          v-model="data_local.email"
          v-validate="'email'"
          type="email"
          name="email"
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <div class="w-full mt-4">
          <label class="vs-input--label">{{ $t('entity.state') }}</label>
          <v-select
            v-model="state_local"
            :clearable="false"
            :options="stateOptions"
            v-validate="'required'"
            name="state"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
          <span class="text-danger text-sm" v-show="errors.has('state')">{{ errors.first('state') }}</span>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{
            $t('forms.update')
          }}</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">{{
            $t('forms.reset')
          }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      avatar: null
    }
  },
  computed: {
    stateOptions() {
      return this.$store.getters['enum/selectOptions']('State', 'entity.states')
    },
    state_local: {
      get() {
        return { label: this.$t(`entity.states.${this.data_local.state}`), value: this.data_local.state }
      },
      set(obj) {
        this.data_local.state = obj.value
      }
    },
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {
    save_changes() {
      if (!this.validateForm) return
      this.$store
        .dispatch('userManagement/editUser', { id: this.data_local.id, data: this.data_local })
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: this.$t('forms.successfully_edited')
          })
        })
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
    update_avatar(event) {
      this.$store.dispatch('file/uploadFile', event).then(response => {
        this.data_local.avatar = response.data[0].id
        this.save_changes()
      })
    },
    remove_avatar() {
      this.data_local.avatar = ''
      this.avatar = null
      this.save_changes()
    },
    get_avatar() {
      if (!this.data_local.avatar) return

      this.$store.dispatch('file/downloadFile', this.data_local.avatar).then(response => {
        this.avatar = response
      })
    }
  },
  created() {
    this.get_avatar()
  }
}
</script>
